import { PLATFORM } from '@/constants/platform'
import { useAuthStore } from '@/stores/useAuthStore'

import { ddeApi } from './ddeApi'

export async function setMediaFeedDelay(
  operatorId: string,
  delayValue: number,
  signal?: AbortSignal
): Promise<void> {
  const platform = useAuthStore.getState().platform

  if (platform === PLATFORM.DDE) {
    const numericOperatorId = Number(operatorId)
    await ddeApi.endpoints.operators.addDelay(numericOperatorId, delayValue, signal)
    return
  }

  throw new Error('Unsupported platform')
}
